export { default as CursosGrupalesList } from './Listar';
export { default as CursoGrupalCrear } from './CrearCursosGrupales'
export { default as SeccionCrear } from './CrearSecciones'
